import { Routes } from '@angular/router';

import { BolsasFinanciamentoComponent } from './bolsas-financiamento.component';

export const BOLSAS_FINANCIAMENTO_ROUTER: Routes = [
  {
    path: 'bolsas-financiamento',
    component: BolsasFinanciamentoComponent,
  },
];
